/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
// import BaseWrapper from '../../components/base-wrapper';
import IconImage from '../../components/IconImage';

export default function save( props ) {
	const { className, attributes } = props;
	const { source, iconName, iconImage, url, linkTarget, rel, contentJustification, blockClientId } = attributes;
	const wrapperClasses = classnames(
		className,
		'flex-col-item',
		{
			[ `is-content-justification-${ contentJustification }` ]: contentJustification,
		},
		`gutenify-section-${ blockClientId }`
	);

	return (
		<div { ...useBlockProps.save( { className: wrapperClasses } ) }>
			<a
				href={ url }
				target={ linkTarget }
				rel={ rel }
				className="gutenify-icon-wrapper"
			>
				{ 'icon' === source && <i className={ iconName }></i> }
				{ 'image' === source && ( iconImage && iconImage.url !== 'null' && iconImage.url !== '' ) &&

				<IconImage attributes={ attributes } />

				}
			</a>
		</div>
	);
}
